
export default function GoogleIcon({size=40}:{
    size?:number
}) {
    return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="8" fill="#F8F8F8"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M31.52 20.2729C31.52 19.422 31.4436 18.6038 31.3018 17.8184H20V22.4602H26.4582C26.18 23.9602 25.3345 25.2311 24.0636 26.082V29.0929H27.9418C30.2109 27.0038 31.52 23.9274 31.52 20.2729Z"
              fill="#4285F4"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M20 32.0003C23.24 32.0003 25.9564 30.9257 27.9418 29.093L24.0636 26.0821C22.9891 26.8021 21.6145 27.2275 20 27.2275C16.8745 27.2275 14.2291 25.1166 13.2855 22.2803H9.27637V25.3894C11.2509 29.3112 15.3091 32.0003 20 32.0003Z"
              fill="#34A853"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M13.2855 22.2804C13.0455 21.5604 12.9091 20.7913 12.9091 20.0004C12.9091 19.2095 13.0455 18.4404 13.2855 17.7204V14.6113H9.27636C8.46364 16.2313 8 18.0641 8 20.0004C8 21.9368 8.46364 23.7695 9.27636 25.3895L13.2855 22.2804Z"
              fill="#FBBC05"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M20 12.7727C21.7618 12.7727 23.3436 13.3782 24.5873 14.5673L28.0291 11.1255C25.9509 9.18909 23.2345 8 20 8C15.3091 8 11.2509 10.6891 9.27637 14.6109L13.2855 17.72C14.2291 14.8836 16.8745 12.7727 20 12.7727Z"
              fill="#EA4335"/>
    </svg>

}